import React from 'react';

import { Route, Switch, useRouteMatch } from 'react-router-dom';

import { NotAuthorized } from 'app/components/not-authorized';
import { CardContainer } from 'app/components/shared/card-container';
import AddFareMediaIssuerOrganization from 'app/configuration/fare-media-issuer-organizations/addFareMediaIssuerOrganization';
import FareMediaIssuerOrganizationsTable from 'app/configuration/fare-media-issuer-organizations/FareMediaIssuerOrganizationsTable';
import UpdateFareMediaIssuerOrganization from 'app/configuration/fare-media-issuer-organizations/updateFareMediaIssuerOrganization';
import ViewFareMediaIssuerOrganization from 'app/configuration/fare-media-issuer-organizations/view-FareMediaIssuerOrganization';
import { trimTrailingSlash, useTypedSelector } from 'helpers';
import { hasWriteAccessToFareMediaIssuersOrganisations } from 'selectors';

const FareMediaIssuerOrganizations: React.FC = () => {
  const match = useRouteMatch();
  const baseURL = trimTrailingSlash(match.url);

  const hasWriteAccess = useTypedSelector(
    hasWriteAccessToFareMediaIssuersOrganisations
  );

  return (
    <CardContainer>
      <Switch>
        <Route path={`${baseURL}/new`}>
          {hasWriteAccess ? (
            <AddFareMediaIssuerOrganization />
          ) : (
            <NotAuthorized />
          )}
        </Route>

        <Route path={`${baseURL}/:id/edit`}>
          {hasWriteAccess ? (
            <UpdateFareMediaIssuerOrganization />
          ) : (
            <NotAuthorized />
          )}
        </Route>

        <Route path={`${baseURL}/:id`}>
          <ViewFareMediaIssuerOrganization />
        </Route>

        <Route exact path={`${baseURL}`}>
          <FareMediaIssuerOrganizationsTable />
        </Route>
      </Switch>
    </CardContainer>
  );
};

export { FareMediaIssuerOrganizations };
